import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import dashImg from '../../assets/dash.png'
import { useAuth } from '../../contexts/auth';
import sicrediLogo from '../../assets/logo_sicredi.png'

import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from './styles';
import { Link } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${dashImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#64c832',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: '#FFF',
    fontSize: 20,
    fontWeight: 600
  },
}));



const formScheme = yup.object().shape({
  email:
    yup.string()
      .required()
      .required('Insira o e-mail')
      .matches(/^[a-zA-Z0-9_.-]+@sicredi+.com+.br+$/i, 'E-mail mal formatado'),
  password:
    yup.string()
      .required('Insira a senha')
})

interface IForm {
  email: string
  password: string
}



export default function SignInSide() {
  const classes = useStyles();

  const { register, handleSubmit, formState: { errors }, } = useForm<IForm>({
    resolver: yupResolver(formScheme)
  })

  const { signIn } = useAuth()

  async function handleSubmitForm(data: IForm) {
    await signIn({ ...data })
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />

      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Typography component="h1" variant="h4">
            Bem vindo ao
          </Typography>
          <Typography component="h1" variant="h3" style={{ fontWeight: 800 }}>
            Sicredi Admin
          </Typography>

          <Avatar className={classes.avatar} style={{ marginTop: 30 }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" >
            Realize o login
          </Typography>
          <form className={classes.form} noValidate onSubmit={handleSubmit(handleSubmitForm)}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="E-mail"
              error={errors.email ? true : false}
              autoComplete="email"
              {...register('email')}
              autoFocus
            />
            {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Senha"
              type="password"
              id="password"
              error={errors.password ? true : false}
              {...register('password')}
              autoComplete="current-password"
            />
            {errors.password && <ErrorMessage>{errors.password.message}</ErrorMessage>}


            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Logar
            </Button>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Link to="/register" style={{
                textDecoration: 'none',
                color: '#64c832',
                justifySelf: 'flex-end',
              }}>
                Criar conta
            </Link>
              <Link to="/forgot" style={{
                textDecoration: 'none',
                color: '#64c832',
                justifySelf: 'flex-end',
              }}>
                Esqueceu a sua senha?
            </Link>
            </div>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}
